const SERVICE = "market/business";

const product = async (api, uuid) => {
  console.log("in uuid");
  console.log(uuid);
  return api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/catalogue/${uuid}`);
};
const newProducts = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/catalogue/new", params);

const lists = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process("/catalogue", params);

module.exports = {
  product,
  lists,
  newProducts,
};
